import { NgModule } from '@angular/core';
import { ComponentLibraryAngularComponent } from './component-library-angular.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { CtaButtonComponent } from './components/buttons/cta-button/cta-button.component';
import { GhostButtonComponent } from './components/buttons/ghost-button/ghost-button.component';
import { CheckboxesComponent } from './components/checkbox/checkboxes/checkboxes.component';
import { ToggleComponent } from './components/toggle/toggle.component';
import { RadioButtonComponent } from './components/radio-button/radio-button.component';
import { MaterialModule } from './components/material-module';
import { ChipComponent } from './components/chip/chip.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { SliderComponent } from './components/slider/slider.component';
import { DropdownComponent } from './components/dropdown/dropdown/dropdown.component';
import { SingleInputComponent } from './components/single-input/single-input.component';
import { SearchbarComponent } from './components/searchbar/searchbar.component';
import { AlertNoteComponent } from './components/alert-note/alert-note.component';
import { PeerComponent } from './components/peer/peer.component';
import { BarChartComponent } from './components/charts/bar-chart/bar-chart.component';
import { LineChartComponent } from './components/charts/line-chart/line-chart.component';
import { PieChartComponent } from './components/charts/pie-chart/pie-chart.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { InputComponent } from './components/input/input.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { AccordionTableComponent } from './components/accordion-table/accordion-table.component';
import { AccordionRowComponent } from './components/accordion-table/accordion-row/accordion-row.component';
import { AccordionRowBodyComponent } from './components/accordion-table/accordion-row-body/accordion-row-body.component';
import { AccordionCellComponent } from './components/accordion-table/accordion-cell/accordion-cell.component';
import { AccordionHeaderComponent } from './components/accordion-table/accordion-header/accordion-header.component';
import { TableComponent } from './components/table/table.component';
import { TableHeadComponent } from './components/table/table-head/table-head.component';
import { TableHeaderComponent } from './components/table/table-header/table-header.component';
import { TableRowComponent } from './components/table/table-row/table-row.component';
import { TableCellComponent } from './components/table/table-cell/table-cell.component';
import { ModalComponent } from './components/modal/modal.component';
import { AddressModalComponent } from './components/modal/address-modal/address-modal.component';
import { AutocompleteCheckboxComponent } from './components/checkbox/autocomplete-checkbox/autocomplete-checkbox.component';
import { DatepickerTextComponent } from './components/datepicker/datepicker-text/datepicker-text.component';
import { SidenavComponent } from './components/navigation/sidenav/sidenav.component';
import { DatepickerMonthYearComponent } from './components/datepicker/datepicker-month-year/datepicker-month-year.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ImageLoaderModalComponent } from './components/modal/image-loader-modal/image-loader-modal.component';
import { DragAndDropDirective } from './directives/modal/drag-and-drop.directive';
import { FileinputProgressBarComponent } from './components/modal/fileinput-progress-bar/fileinput-progress-bar.component';
import { DatepickerKeyboardComponent } from './components/datepicker/datepicker-keyboard/datepicker-keyboard.component';
import { ImageDisplayModalComponent } from './components/modal/image-display-modal/image-display-modal.component';
import { ThreeDotMenuComponent } from './components/menu/three-dot-menu/three-dot-menu.component';
import { TableExpandCollapseComponent } from './components/table-expand-collapse/table-expand-collapse.component';
import { DonutChartComponent } from './components/charts/donut-chart/donut-chart.component';
import { EmployeeTableComponent } from './components/employee-table/employee-table.component';
import { TextButtonsComponent } from './components/text-buttons/text-buttons.component';
import { CheckboxTableComponent } from './components/checkbox-table/checkbox-table.component';
import { DoubleBarChartComponent } from './components/charts/double-bar-chart/double-bar-chart.component';
import { PieDouChartComponent } from './components/charts/pie-dou-chart/pie-dou-chart.component';
import { AvatarTableComponent } from './components/avatar-table/avatar-table.component';
import { DatepickerYearComponent } from './components/datepicker/datepicker-year/datepicker-year.component';
import { DatepickerHorizontalComponent } from './components/datepicker/datepicker-horizontal/datepicker-horizontal.component';
import { InputTableComponent } from './components/input-table/input-table.component';
import { DynamicFormQuestionComponent } from './components/dynamic-form/dynamic-form-question/dynamic-form-question.component';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form/dynamic-form.component';
import { CurrencyPipe } from '@angular/common';
import { SingleImageLoaderComponent } from './components/modal/single-image-loader/single-image-loader.component';
import { CsvMenuComponent } from './components/menu/csv-menu/csv-menu.component';
import { InputGenericTableComponent } from './components/input-generic-table/input-generic-table.component';
import { OnlyNumberDirective } from './directives/modal/only-numbers.directive';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { AutocompleteDropdownComponent } from './components/dropdown/autocomplete-dropdown/autocomplete-dropdown.component';
import { PDFViewerComponent } from './components/pdfviewer/pdfviewer.component';
import { PDFViewerModalComponent } from './components/modal/pdfviewer-modal/pdfviewer-modal.component';
import { SafePipe } from './pipes/safe-pipe/safe.pipe';
import { FilterDropdownComponent } from './components/dropdown/filter-dropdown/filter-dropdown.component';
import { TableContainerComponent } from './components/table-container/table-container.component';
import { RouterModule } from '@angular/router';
import { DocsGooglePipe } from './pipes/docsGoogle-pipe/docs-google.pipe';

const components = [
  ComponentLibraryAngularComponent,
  CtaButtonComponent,
  GhostButtonComponent,
  CheckboxesComponent,
  ToggleComponent,
  RadioButtonComponent,
  ChipComponent,
  SnackbarComponent,
  SliderComponent,
  DropdownComponent,
  SingleInputComponent,
  SearchbarComponent,
  AlertNoteComponent,
  PeerComponent,
  BarChartComponent,
  LineChartComponent,
  PieChartComponent,
  TabsComponent,
  InputComponent,
  ProgressBarComponent,
  AccordionTableComponent,
  AccordionRowComponent,
  AccordionRowBodyComponent,
  AccordionCellComponent,
  AccordionHeaderComponent,
  TableComponent,
  TableHeadComponent,
  TableHeaderComponent,
  TableRowComponent,
  TableCellComponent,
  ModalComponent,
  AddressModalComponent,
  AutocompleteCheckboxComponent,
  DatepickerTextComponent,
  SidenavComponent,
  DatepickerMonthYearComponent,
  ImageLoaderModalComponent,
  DragAndDropDirective,
  FileinputProgressBarComponent,
  DatepickerKeyboardComponent,
  ThreeDotMenuComponent,
  ImageDisplayModalComponent,
  ThreeDotMenuComponent,
  CheckboxTableComponent,
  DoubleBarChartComponent,
  PieDouChartComponent,
  TableExpandCollapseComponent,
  EmployeeTableComponent,
  TextButtonsComponent,
  DonutChartComponent,
  CheckboxTableComponent,
  AvatarTableComponent,
  DatepickerYearComponent,
  DatepickerHorizontalComponent,
  InputTableComponent,
  SingleImageLoaderComponent,
  DynamicFormQuestionComponent,
  DynamicFormComponent,
  CsvMenuComponent,
  InputGenericTableComponent,
  SpinnerComponent,
  SearchInputComponent,
  AutocompleteDropdownComponent,
  FilterDropdownComponent,
  PDFViewerComponent,
  PDFViewerModalComponent,
  TableContainerComponent,
];

@NgModule({
  declarations: [...components, OnlyNumberDirective, SafePipe, DocsGooglePipe],
  imports: [
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    NgxChartsModule,
    RouterModule,
  ],
  exports: [...components],
  providers: [CurrencyPipe],
})
export class ComponentLibraryAngularModule {}
